import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface ComponentProps {
  toPath: string;
  title: string;
  number: any;
}

const Card = ({ toPath, title, number }: ComponentProps) => {
  return (
    <Wrapper to={toPath}>
      <Title>{title}</Title>
      <NumberOfQuotes>{number}</NumberOfQuotes>
    </Wrapper>
  );
};

export default Card;

const Wrapper = styled(Link)<any>`
  display: inline-flex;
  height: 200px;
  width: 30%;
  background-color: rgba(93, 165, 237, 0.05);
  border: 2px solid #5da6ed;
  cursor: pointer;
  margin-bottom: 0;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 576px) {
    width: 100%;
    margin-bottom: 10px;
    height: 150px;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-family: font-bold;
  font-weight: 700;
  color: #5da6ed;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const NumberOfQuotes = styled.div`
  font-size: 22px;
  font-family: font-semibold;
  font-weight: 600;
  color: #5da6ed;
`;
